import { render, staticRenderFns } from "./UploadTab.vue?vue&type=template&id=9e51b9d4&scoped=true&"
import script from "./UploadTab.vue?vue&type=script&lang=js&"
export * from "./UploadTab.vue?vue&type=script&lang=js&"
import style0 from "./UploadTab.vue?vue&type=style&index=0&id=9e51b9d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e51b9d4",
  null
  
)

export default component.exports